import { j as c } from "../../jsx-runtime-B6kdoens.js";
import { useContext as k, useMemo as C } from "react";
import { c as b, f as T } from "../../create-component-CBAeEoQ6.js";
import { F as N } from "../../FormControlContext-C7A4R-3o.js";
import { c as h } from "../../index-CROKJrb5.js";
import { Typography as y } from "../Typography/index.js";
import { u as S } from "../../use-unique-id-BA9hSqap.js";
const L = (e, s) => s ? "disabled" : e === "" || !e ? "default" : e, M = h({
  base: "cur-relative cur-group cur-flex-none cur-rounded-full focus-within:cur-ring-offset-white focus-within:cur-ring-2",
  variants: {
    size: {
      sm: "cur-h-[1.5rem] cur-w-[2.375rem] focus-within:cur-ring-offset-2",
      md: "cur-h-[2.25rem] cur-w-[3.75rem] focus-within:cur-ring-offset-[3px]"
    },
    state: {
      default: "focus-within:cur-border-focus focus-within:cur-ring-focus",
      critical: "focus-within:cur-ring-border-error",
      warning: "focus-within:cur-ring-border-warning",
      success: "focus-within:cur-ring-border-success",
      disabled: null
    }
  }
}), z = h({
  base: "cur-absolute cur-rounded-full cur-transition-all peer-checked:cur-scale-100 cur-top-1/2 -cur-translate-y-1/2",
  variants: {
    size: {
      sm: "cur-h-[1rem] cur-w-[1rem] cur-scale-[.625] cur-left-[0.25rem] peer-checked:cur-left-[1.15rem]",
      md: "cur-h-[1.625rem] cur-w-[1.625rem] cur-scale-[.75] cur-left-[0.4rem] peer-checked:cur-left-[1.75rem]"
    },
    state: {
      default: "cur-bg-disabled peer-checked:cur-bg-surface-brand-accent",
      critical: "cur-bg-surface-error-hover peer-checked:cur-bg-border-error",
      warning: "cur-bg-surface-warning-hover peer-checked:cur-bg-border-warning",
      success: "cur-bg-surface-success-hover peer-checked:cur-bg-border-success",
      disabled: "cur-bg-border-disabled"
    }
  }
}), A = h({
  base: "cur-absolute cur-inset-0 -cur-z-20 cur-rounded-full",
  variants: {
    size: {
      sm: "cur-border-2",
      md: "cur-border-3"
    },
    state: {
      default: "cur-border-border-secondary",
      critical: "cur-border-border-error",
      warning: "cur-border-border-warning",
      success: "cur-border-border-success",
      disabled: "cur-border-border-disabled"
    }
  }
}), B = h({
  base: "cur-absolute cur-inset-1/2 -cur-z-30 cur-block cur-opacity-0 -cur-translate-x-1/2 -cur-translate-y-1/2 cur-rounded-full cur-bg-surface-highlight cur-transition-all",
  variants: {
    size: {
      sm: "cur-h-[2.25rem] cur-w-[3.125rem]",
      md: "cur-h-[3rem] cur-w-[4.5rem]"
    },
    disabled: {
      false: "group-hover:cur-opacity-100"
    }
  }
}), F = b(
  "ToggleSlider",
  T(
    ({
      as: e,
      children: s,
      disabled: t = !1,
      id: i,
      onClick: x,
      size: u = "md",
      type: o = "checkbox",
      state: a = "",
      ...d
    }, g) => {
      const n = e || "input", m = L(a, t), w = M({
        size: u,
        state: m
      }), r = z({
        size: u,
        state: m
      }), p = A({
        size: u,
        state: m
      }), f = B({
        disabled: t,
        size: u
      });
      return /* @__PURE__ */ c.jsxs("div", { className: w, children: [
        /* @__PURE__ */ c.jsxs("div", { className: "cur-absolute cur-inset-0 cur-overflow-hidden", children: [
          /* @__PURE__ */ c.jsx(
            n,
            {
              onClick: x,
              className: "cur-peer cur-absolute cur-left-0 cur-top-0 cur-z-10 cur-h-full cur-w-full cur-opacity-0",
              type: o,
              id: i,
              state: a,
              disabled: t,
              ...d,
              ref: g
            }
          ),
          /* @__PURE__ */ c.jsx("div", { className: r, "aria-hidden": !0 }),
          /* @__PURE__ */ c.jsx("div", { className: p, "aria-hidden": !0 })
        ] }),
        /* @__PURE__ */ c.jsx("div", { className: f, "aria-hidden": !0 })
      ] });
    }
  )
), D = b(
  "ToggleMainLabel",
  ({ children: e, ...s }) => /* @__PURE__ */ c.jsx(y, { ...s, children: e })
), I = b(
  "ToggleMeta",
  ({ children: e, ...s }) => /* @__PURE__ */ c.jsx(
    y,
    {
      className: "cur-ml-2",
      size: "meta",
      ...s,
      children: e
    }
  )
), R = h({
  base: "cur-flex cur-flex-col",
  variants: {
    size: {
      sm: null,
      md: "cur-mt-[0.375rem]"
    }
  }
}), W = b(
  "ToggleLabel",
  ({ label: e, meta: s, id: t, size: i = "md" }) => /* @__PURE__ */ c.jsxs("label", { className: R({ size: i }), htmlFor: t, children: [
    /* @__PURE__ */ c.jsx(D, { children: e }),
    s ? /* @__PURE__ */ c.jsx(I, { className: "cur-mt-1 cur-text-subtle", children: s }) : null
  ] })
), K = b(
  "ToggleBase",
  T(
    ({
      checked: e,
      className: s,
      id: t,
      label: i,
      meta: x,
      name: u,
      onChange: o,
      size: a = "md",
      state: d = "",
      type: g = "checkbox",
      value: n,
      ...m
    }, w) => {
      const r = k(N), p = S("toggle", t);
      u = u || r.name, a = a || r.size, d = d || r.state || "", g = g || r.type;
      const f = C(
        () => o || r.onChange ? (l) => {
          var j;
          o == null || o(l, l.target.value), (j = r.onChange) == null || j.call(r, l, l.target.value);
        } : void 0,
        [o, r]
      ), v = C(() => {
        var l;
        if (e) return e;
        if (f)
          return Array.isArray(r.value) ? (l = r.value) == null ? void 0 : l.includes(n) : r.value !== void 0 && r.value === n;
      }, [e, f, n, r.value]);
      return /* @__PURE__ */ c.jsx("div", { className: s, role: "option", "aria-selected": v, children: /* @__PURE__ */ c.jsxs("div", { className: "cur-flex cur-items-start cur-justify-between cur-gap-2", children: [
        i ? /* @__PURE__ */ c.jsx(W, { id: p, label: i, meta: x, size: a }) : null,
        /* @__PURE__ */ c.jsx(
          F,
          {
            checked: v,
            onChange: f,
            ref: w,
            size: a,
            state: d,
            type: g,
            value: n,
            id: p,
            name: u,
            ...m
          }
        )
      ] }) });
    }
  )
);
export {
  K as Toggle
};
//# sourceMappingURL=index.js.map
